export const gossipList = [
  {
    id: "gt-2026-0912-edu",
    title: "选秀出道成员被指学历履历造假，公开资料与可查记录对不上",
    category: "学历履历",
    summary:
      "有网友整理出该成员在不同场合公开的求学经历共三个版本，其中两段学历在对应院校的公开查询入口均未找到匹配记录，团队此前回应称“资料由早期经纪方整理”。",
    credibility: 91,
    verdict: "实锤",
    heat: 20400,
    publishedAt: "2026-09-09",
    readMinutes: 7,
    tags: ["履历比对", "公开记录", "多版本陈述"],
    cover: "https://readdy.ai/api/search-image?query=stack%20of%20vintage%20paper%20documents%20and%20folders%20on%20dark%20wooden%20desk%2C%20warm%20amber%20light%2C%20editorial%20archive%20still%20life%2C%20muted%20cream%20and%20crimson%20tones%2C%20high%20detail&width=800&height=600&seq=gt-edu-2026&orientation=landscape",
    coverAlt: "学历履历造假爆料鉴定：桌面上的档案与文件资料",
    conclusion:
      "综合公开访谈、早期宣传物料与院校可查记录三方比对，三处履历陈述存在实质性冲突，且已有两处被独立核验为不成立，判定为实锤。",
    evidence: [
      {
        id: "e1",
        type: "公开访谈",
        title: "本人两次自述求学时间线互相矛盾",
        detail: "2024 年直播与 2025 年杂志专访中对入学年份、就读城市的描述相差两年且不重叠，属同一人同一经历的两种版本。",
        weight: "高",
      },
      {
        id: "e2",
        type: "公开可查记录",
        title: "院校公开查询入口无对应记录",
        detail: "网友按本人所述专业与年份检索两所院校的公开查询入口，均未返回匹配条目，检索过程录屏已公开。",
        weight: "高",
      },
      {
        id: "e3",
        type: "早期宣传物料",
        title: "出道前宣传页履历与现版本不一致",
        detail: "归档快照显示 2023 年出道宣传页写的是另一段经历，该页面在事件发酵后被修改。",
        weight: "中",
      },
      {
        id: "e4",
        type: "团队回应",
        title: "团队称“资料由早期经纪方整理”",
        detail: "回应未正面解释时间线冲突，也未提供任何可核验材料，属于回避式表述。",
        weight: "中",
      },
    ],
    timeline: [
      { time: "09-06 21:40", event: "网友发布履历比对长图，串联三个版本的公开陈述。" },
      { time: "09-07 11:05", event: "相关话题进入热搜，检索录屏被大量转发。" },
      { time: "09-08 15:20", event: "团队发布简短声明，称资料由早期经纪方整理。" },
      { time: "09-09 10:00", event: "瓜田爆料完成三方比对，给出实锤结论并公开评估维度。" },
    ],
    sources: [
      { name: "本人公开直播录像", type: "当事人陈述", note: "可回看，时间戳完整" },
      { name: "院校公开查询入口", type: "公开记录", note: "不含个人隐私信息，仅返回有无匹配" },
      { name: "网页归档快照", type: "第三方存档", note: "含存档时间戳" },
      { name: "团队官方声明", type: "官方回应", note: "短声明，未附材料" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 92, note: "核心陈述均来自本人公开影像" },
      { dimension: "证据链完整度", score: 90, note: "陈述—记录—快照形成闭环" },
      { dimension: "多方交叉印证", score: 88, note: "两名独立整理者结论一致" },
      { dimension: "官方回应情况", score: 55, note: "已回应但回避关键问题" },
    ],
  },
  {
    id: "gt-2026-0911-pay",
    title: "某剧组被曝长期拖欠演员与场务薪酬，多名从业者说法一致",
    category: "团队纠纷",
    summary:
      "爆料称该剧杀青后数月，群演与场务的尾款仍未结清。多名互不认识的从业者在不同平台给出高度一致的细节，包括结算时间、对接人称呼与欠款比例。",
    credibility: 88,
    verdict: "实锤",
    heat: 11800,
    publishedAt: "2026-09-08",
    readMinutes: 6,
    tags: ["片酬结算", "从业者口述", "细节一致"],
    cover: "https://readdy.ai/api/search-image?query=empty%20film%20production%20set%20at%20dusk%20with%20folded%20chairs%20and%20lighting%20rigs%2C%20moody%20muted%20tones%2C%20dusty%20warm%20light%2C%20editorial%20documentary%20photography%2C%20high%20detail&width=800&height=600&seq=gt-pay-2026&orientation=landscape",
    coverAlt: "剧组拖欠薪酬爆料鉴定：黄昏中收工后的片场",
    conclusion:
      "多位互不相识的从业者在细节层面高度一致，且部分人公开了结算单据的遮挡版，交叉印证充分，判定为实锤；具体金额与责任方仍需以合同为准。",
    evidence: [
      {
        id: "e1",
        type: "从业者口述",
        title: "四名不同岗位从业者描述一致",
        detail: "场务、群演、化妆助理、灯光助理分属不同团队，对结算节点、对接人称谓与比例的表述几乎一致。",
        weight: "高",
      },
      {
        id: "e2",
        type: "单据材料",
        title: "公开了遮挡后的结算单",
        detail: "单据含项目代号与结算日期，与口述时间线吻合，敏感信息已遮挡。",
        weight: "高",
      },
      {
        id: "e3",
        type: "时间线",
        title: "杀青时间与欠款周期吻合",
        detail: "公开的杀青物料时间与从业者描述的结算周期一致，无时间冲突。",
        weight: "中",
      },
      {
        id: "e4",
        type: "反证核查",
        title: "未发现有效反证",
        detail: "制作方暂无公开回应，也没有从业者出面否认欠薪说法。",
        weight: "中",
      },
    ],
    timeline: [
      { time: "09-03 18:10", event: "首位场务在社交平台描述尾款未结清。" },
      { time: "09-05 09:30", event: "另外三名从业者先后补充细节，说法高度接近。" },
      { time: "09-06 20:00", event: "遮挡版结算单被公开，时间线与口述吻合。" },
      { time: "09-08 09:00", event: "瓜田爆料完成交叉核对，判定为实锤。" },
    ],
    sources: [
      { name: "从业者公开发言", type: "当事人陈述", note: "四人分属不同团队" },
      { name: "遮挡版结算单据", type: "材料佐证", note: "敏感信息已处理" },
      { name: "剧组公开物料", type: "公开记录", note: "用于核对时间线" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 82, note: "以匿名从业者为主，岗位可交叉确认" },
      { dimension: "证据链完整度", score: 88, note: "口述与单据可互证" },
      { dimension: "多方交叉印证", score: 93, note: "四名独立从业者说辞一致" },
      { dimension: "官方回应情况", score: 50, note: "制作方暂未回应" },
    ],
  },
  {
    id: "gt-2026-0910-plagiarism",
    title: "新歌被指旋律与他人作品高度相似，工作室已发声明回应",
    category: "口碑争议",
    summary:
      "作品上线后被指出主歌部分与三年前一首独立作品在音程走向与节奏型上高度接近。工作室回应称“创作过程中未参考该作品”，但未提供创作过程材料。",
    credibility: 84,
    verdict: "实锤",
    heat: 13200,
    publishedAt: "2026-09-07",
    readMinutes: 5,
    tags: ["旋律比对", "创作时间线", "官方声明"],
    cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20vintage%20audio%20waveform%20on%20cream%20paper%20with%20brass%20headphones%2C%20warm%20amber%20and%20deep%20red%20accents%2C%20editorial%20music%20magazine%20still%20life%2C%20high%20detail&width=800&height=600&seq=gt-music-2026&orientation=landscape",
    coverAlt: "音乐旋律抄袭爆料鉴定：纸面波形与耳机",
    conclusion:
      "音程走向、节奏型与段落结构三项比对结果高度接近，超过独立创作为巧合的常见区间；工作室的否认缺少过程材料支撑，判定为实锤（作品层面相似成立）。",
    evidence: [
      {
        id: "e1",
        type: "技术比对",
        title: "主歌音程走向高度重合",
        detail: "两段旋律在相同调性下的音程走向一致度高，段落结构也呈现相同排布。",
        weight: "高",
      },
      {
        id: "e2",
        type: "发表时间线",
        title: "独立作品发表时间更早且可查",
        detail: "被比对作品发表于三年前，平台发布时间戳与备份均可核验。",
        weight: "高",
      },
      {
        id: "e3",
        type: "乐队回应",
        title: "独立音乐人回应态度克制",
        detail: "原作者仅表示“希望有个说明”，未指责，也未提出索赔。",
        weight: "中",
      },
      {
        id: "e4",
        type: "官方声明",
        title: "工作室否认但无过程材料",
        detail: "声明仅口头否认，未公开 demo 时间戳或创作记录。",
        weight: "中",
      },
    ],
    timeline: [
      { time: "09-04 22:15", event: "乐评账号发布旋律比对视频。" },
      { time: "09-05 14:00", event: "被比对作品原作者首次公开回应，态度克制。" },
      { time: "09-06 17:40", event: "工作室发布声明，否认参考该作品。" },
      { time: "09-07 10:30", event: "瓜田爆料给出作品层面相似成立的实锤结论。" },
    ],
    sources: [
      { name: "两首作品音频", type: "公开材料", note: "可自行比对" },
      { name: "平台发表记录", type: "公开记录", note: "含发布时间戳" },
      { name: "原作者公开发言", type: "当事人陈述", note: "态度克制" },
      { name: "工作室声明", type: "官方回应", note: "未附过程材料" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 90, note: "音频与发表记录均可独立获取" },
      { dimension: "证据链完整度", score: 84, note: "比对结论清晰，动机无法判断" },
      { dimension: "多方交叉印证", score: 80, note: "多名乐评人判断趋同" },
      { dimension: "官方回应情况", score: 62, note: "有声明但缺材料" },
    ],
  },
  {
    id: "gt-2026-0910-cp",
    title: "古装剧男女主疑似假戏真做，同款与行程被反复比对",
    category: "恋情绯闻",
    summary:
      "两人被扒出多件同款单品与前后相接的行程，其中一次被指出在同一城市停留。但同款在剧组属于常见道具借用，行程重合也可能来自剧宣安排。",
    credibility: 68,
    verdict: "存疑",
    heat: 15200,
    publishedAt: "2026-09-06",
    readMinutes: 6,
    tags: ["同款单品", "行程重合", "剧组道具"],
    cover: "https://readdy.ai/api/search-image?query=warm%20autumn%20street%20scene%20with%20two%20distant%20silhouettes%20and%20falling%20yellow%20leaves%2C%20soft%20muted%20cinematic%20light%2C%20editorial%20photography%2C%20cream%20and%20amber%20tones%2C%20high%20detail&width=800&height=600&seq=gt-cp-2026&orientation=landscape",
    coverAlt: "恋情绯闻爆料鉴定：秋日街道与远处身影",
    conclusion:
      "倾向成立但未闭环：同款与行程属于弱证据，且剧宣共用造型、集中宣传行程都能解释，缺少能排除其他可能的关键一环，暂列存疑。",
    evidence: [
      {
        id: "e1",
        type: "同款比对",
        title: "至少四件单品被发现同款",
        detail: "包含帽子、外套与配饰，其中两件为品牌非限量款，撞款概率较高。",
        weight: "低",
      },
      {
        id: "e2",
        type: "行程时间线",
        title: "两次相邻行程在同一城市",
        detail: "时间上前后相接，但同城期间均有剧方公开活动记录。",
        weight: "中",
      },
      {
        id: "e3",
        type: "剧组背景",
        title: "剧组存在共用造型的可能",
        detail: "同组演员此前也被拍到同款造型，削弱了同款作为证据的独立性。",
        weight: "中",
      },
      {
        id: "e4",
        type: "双方回应",
        title: "双方均未回应该传闻",
        detail: "工作室对恋情传闻一贯不予回应，因此沉默无法作为任何一方的证据。",
        weight: "低",
      },
    ],
    timeline: [
      { time: "08-30 19:20", event: "剧粉整理同款清单并发布长图。" },
      { time: "09-02 12:00", event: "行程重合被追加，话题热度上升。" },
      { time: "09-04 16:30", event: "有网友指出剧组共用造型的先例。" },
      { time: "09-06 10:00", event: "瓜田爆料评估为存疑，列出可解释路径。" },
    ],
    sources: [
      { name: "剧粉整理长图", type: "网友整理", note: "含时间线标注" },
      { name: "品牌公开款式信息", type: "公开记录", note: "用于判断撞款概率" },
      { name: "剧方公开活动记录", type: "官方物料", note: "用于核对同城原因" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 70, note: "图片来源可查，但缺一手信息" },
      { dimension: "证据链完整度", score: 58, note: "弱证据为主，未闭环" },
      { dimension: "多方交叉印证", score: 64, note: "整理者众多但同源" },
      { dimension: "官方回应情况", score: 40, note: "双方未回应" },
    ],
  },
  {
    id: "gt-2026-0905-cp",
    title: "综艺 CP 被扒同款行程与相邻座位，节目组尚未回应",
    category: "恋情绯闻",
    summary:
      "两人在综艺中的互动被反复剪出对比，加上一次机场的相邻拍摄时间，被部分网友认为是关系超出节目设定。相关素材多为节目剪辑与公开行程。",
    credibility: 74,
    verdict: "存疑",
    heat: 9800,
    publishedAt: "2026-09-05",
    readMinutes: 5,
    tags: ["节目互动", "公开行程", "剪辑语境"],
    cover: "https://readdy.ai/api/search-image?query=empty%20television%20studio%20with%20warm%20stage%20lights%20and%20two%20vacant%20director%20chairs%2C%20soft%20amber%20glow%2C%20editorial%20magazine%20photography%2C%20muted%20cream%20and%20deep%20red%20palette%2C%20high%20detail&width=800&height=600&seq=gt-show-2026&orientation=landscape",
    coverAlt: "综艺CP爆料鉴定：暖光演播厅与空座椅",
    conclusion:
      "互动素材成立、关系推断不成立。公开影像能证明两人关系融洽，但从融洽到恋爱判断缺少独立证据，属典型的相关不等于因果，列为存疑。",
    evidence: [
      {
        id: "e1",
        type: "节目素材",
        title: "互动片段被大量二次剪辑",
        detail: "原始节目素材能确认互动频繁，但剪辑强化了氛围，不能直接推导关系性质。",
        weight: "中",
      },
      {
        id: "e2",
        type: "行程记录",
        title: "一次机场时间相邻",
        detail: "两人航班时间接近，但目的地不同，相邻不代表同行。",
        weight: "低",
      },
      {
        id: "e3",
        type: "节目设定",
        title: "节目本身以 CP 为卖点",
        detail: "节目宣发长期使用 CP 话题，互动呈现存在剪辑导向。",
        weight: "中",
      },
      {
        id: "e4",
        type: "回应情况",
        title: "节目组与双方均未回应",
        detail: "暂无否认，也无确认。",
        weight: "低",
      },
    ],
    timeline: [
      { time: "08-29 20:00", event: "CP 剪辑视频在短视频平台扩散。" },
      { time: "08-31 13:20", event: "机场行程时间相邻被追加为“新证据”。" },
      { time: "09-03 11:00", event: "有观众指出节目剪辑存在氛围强化。" },
      { time: "09-05 09:30", event: "瓜田爆料判定为存疑，拆解了相关与因果的区别。" },
    ],
    sources: [
      { name: "节目正片素材", type: "公开材料", note: "可自行比对前后语境" },
      { name: "公开航班信息", type: "公开记录", note: "仅能证明时间接近" },
      { name: "节目宣发物料", type: "官方物料", note: "长期使用 CP 话题" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 78, note: "素材公开可回看" },
      { dimension: "证据链完整度", score: 62, note: "推断环节缺关键证据" },
      { dimension: "多方交叉印证", score: 70, note: "同源素材被反复引用" },
      { dimension: "官方回应情况", score: 45, note: "暂无回应" },
    ],
  },
  {
    id: "gt-2026-0904-salary",
    title: "综艺常驻因薪资谈崩退出，节目名单已悄然调整",
    category: "事业动向",
    summary:
      "新一季嘉宾名单公布后，原常驻未出现在名单中。爆料称双方因报价分歧未续约，节目方与艺人方均未说明原因。名单变动本身可核验，原因属于推断。",
    credibility: 79,
    verdict: "存疑",
    heat: 8800,
    publishedAt: "2026-09-04",
    readMinutes: 5,
    tags: ["嘉宾名单", "合约变动", "原因推断"],
    cover: "https://readdy.ai/api/search-image?query=fountain%20pen%20resting%20on%20unsigned%20contract%20papers%20beside%20a%20cup%20of%20tea%2C%20warm%20afternoon%20light%2C%20editorial%20business%20still%20life%2C%20cream%20and%20muted%20green%20tones%2C%20high%20detail&width=800&height=600&seq=gt-contract-2026&orientation=landscape",
    coverAlt: "综艺嘉宾退出爆料鉴定：桌面上的合约文件",
    conclusion:
      "名单变动成立，退出原因未闭环。可核验部分支持“未续约”这一事实判断，但“因薪资谈崩”仅来自单一爆料渠道，列为存疑。",
    evidence: [
      {
        id: "e1",
        type: "可核验事实",
        title: "官方名单确无该常驻",
        detail: "新一季公布的常驻名单中不含此人，与上季形成明确对比。",
        weight: "高",
      },
      {
        id: "e2",
        type: "渠道爆料",
        title: "单一渠道称报价分歧",
        detail: "该说法仅有一位自称接近制作方的人提及，无第二来源佐证。",
        weight: "低",
      },
      {
        id: "e3",
        type: "档期排期",
        title: "同时段有另一档常驻节目",
        detail: "档期冲突同样可以解释缺席，属于合理解释路径之一。",
        weight: "中",
      },
      {
        id: "e4",
        type: "回应情况",
        title: "双方均未说明原因",
        detail: "节目方仅表示“档期原因”，未展开。",
        weight: "低",
      },
    ],
    timeline: [
      { time: "08-28 10:00", event: "新一季常驻名单公布，原常驻缺席。" },
      { time: "08-30 21:10", event: "有渠道称分歧来自报价。" },
      { time: "09-02 15:00", event: "网友指出同时段另有常驻节目，档期冲突存在可能。" },
      { time: "09-04 09:00", event: "瓜田爆料判定名单变动属实、原因列为存疑。" },
    ],
    sources: [
      { name: "节目官方名单", type: "官方物料", note: "可逐季对比" },
      { name: "渠道匿名爆料", type: "单一来源", note: "无可佐证材料" },
      { name: "公开档期信息", type: "公开记录", note: "用于核对档期冲突" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 74, note: "事实部分来源官方" },
      { dimension: "证据链完整度", score: 66, note: "原因环节依赖单一来源" },
      { dimension: "多方交叉印证", score: 70, note: "事实可印证，原因不可" },
      { dimension: "官方回应情况", score: 52, note: "回应笼统" },
    ],
  },
  {
    id: "gt-2026-0903-reunion",
    title: "老牌组合被传将重聚开唱，成员互动引发猜测",
    category: "事业动向",
    summary:
      "组合成员近期在社交平台互相关注并有一次同框，被解读为重聚信号。但同框出现在公开活动，互关也可能只是常规社交，缺少演出层面的实质线索。",
    credibility: 57,
    verdict: "待定",
    heat: 6400,
    publishedAt: "2026-09-03",
    readMinutes: 4,
    tags: ["同框同台", "社交互动", "演出线索"],
    cover: "https://readdy.ai/api/search-image?query=empty%20concert%20stage%20with%20spotlights%20and%20microphone%20stand%20before%20show%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20editorial%20music%20magazine%20photography%2C%20muted%20tones%2C%20high%20detail&width=800&height=600&seq=gt-reunion-2026&orientation=landscape",
    coverAlt: "老牌组合重聚爆料鉴定：开演前的舞台灯光",
    conclusion:
      "线索零散且来源等级偏低，同框与互关都能用常规社交解释，缺少演出备案、场馆或主创方面的实质线索，暂列待定，继续观察。",
    evidence: [
      {
        id: "e1",
        type: "社交互动",
        title: "成员互相关注并有一次点赞",
        detail: "属常规社交行为，单独不足以支撑重聚判断。",
        weight: "低",
      },
      {
        id: "e2",
        type: "公开活动",
        title: "一次公开活动的同框合影",
        detail: "合影来自品牌活动，属于工作场合，非私下相约。",
        weight: "中",
      },
      {
        id: "e3",
        type: "反证核查",
        title: "未查到演出备案与场馆信息",
        detail: "按常规流程，大型演出会留下可查的备案与场地线索，目前均无。",
        weight: "中",
      },
      {
        id: "e4",
        type: "回应情况",
        title: "相关方未回应",
        detail: "无可确认来源。",
        weight: "低",
      },
    ],
    timeline: [
      { time: "08-26 20:30", event: "成员互关被粉丝发现并讨论。" },
      { time: "08-29 18:00", event: "品牌活动现场同框合影流出。" },
      { time: "09-01 12:00", event: "有账号称“已在接洽”，但无材料。" },
      { time: "09-03 09:00", event: "瓜田爆料判定为待定，列出待确认线索。" },
    ],
    sources: [
      { name: "成员社交账号", type: "公开记录", note: "互动可查" },
      { name: "品牌活动图集", type: "公开物料", note: "工作场合" },
      { name: "演出备案公开信息", type: "公开记录", note: "暂未查到相关条目" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 62, note: "公开痕迹可查" },
      { dimension: "证据链完整度", score: 42, note: "缺实质环节" },
      { dimension: "多方交叉印证", score: 55, note: "以粉丝解读为主" },
      { dimension: "官方回应情况", score: 30, note: "无回应" },
    ],
  },
  {
    id: "gt-2026-0828-attitude",
    title: "导演被曝片场态度恶劣，多名在场者回应与爆料不符",
    category: "口碑争议",
    summary:
      "爆料称某导演在片场对工作人员发脾气并摔东西。事件发酵后，数名自称在场的从业者公开说明当天情况，描述与爆料存在明显出入，现场录制花絮也未出现相关画面。",
    credibility: 26,
    verdict: "辟谣",
    heat: 7300,
    publishedAt: "2026-08-28",
    readMinutes: 4,
    tags: ["在场者回应", "花絮核对", "爆料不符"],
    cover: "https://readdy.ai/api/search-image?query=empty%20film%20set%20with%20clapperboard%20and%20monitor%20on%20a%20folding%20table%2C%20soft%20overcast%20light%2C%20editorial%20documentary%20photography%2C%20muted%20green%20and%20cream%20tones%2C%20high%20detail&width=800&height=600&seq=gt-attitude-2026&orientation=landscape",
    coverAlt: "导演片场态度爆料鉴定：片场监视器与场记板",
    conclusion:
      "出现多项反向证据：多名在场者说法与爆料不符，官方花絮也未见相关情形，且原始爆料无法提供时间地点等基本要素，判定为不实传闻并归入辟谣汇总。",
    evidence: [
      {
        id: "e1",
        type: "在场者回应",
        title: "三名从业者否认爆料场景",
        detail: "三人岗位不同，均表示当天拍摄正常，未发生描述中的冲突。",
        weight: "中",
      },
      {
        id: "e2",
        type: "花絮核对",
        title: "官方花絮未出现相关画面",
        detail: "当天花絮完整发布，未见爆料所述情形，时间线可对应。",
        weight: "中",
      },
      {
        id: "e3",
        type: "爆料本身",
        title: "原始爆料缺少基本要素",
        detail: "未给出具体日期、地点与可核实场景，属碎片化描述。",
        weight: "低",
      },
      {
        id: "e4",
        type: "后续处理",
        title: "爆料账号已删除原帖",
        detail: "原帖被删除，账号未作说明，这一行为降低了可信度。",
        weight: "中",
      },
    ],
    timeline: [
      { time: "08-24 22:00", event: "匿名账号发布片场态度爆料。" },
      { time: "08-26 14:30", event: "多名在场从业者公开说明当天情况。" },
      { time: "08-27 10:00", event: "官方花絮发布，与爆料描述不符。" },
      { time: "08-28 09:00", event: "瓜田爆料判定为不实，归入辟谣汇总。" },
    ],
    sources: [
      { name: "匿名爆料原帖", type: "单一来源", note: "已删除" },
      { name: "在场从业者发言", type: "当事人陈述", note: "多人独立说明" },
      { name: "官方现场花絮", type: "官方物料", note: "含当天完整时间线" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 20, note: "原帖已删，来源不可查" },
      { dimension: "证据链完整度", score: 18, note: "无任何佐证材料" },
      { dimension: "多方交叉印证", score: 30, note: "反向证据占多数" },
      { dimension: "官方回应情况", score: 40, note: "通过花絮侧面澄清" },
    ],
  },
  {
    id: "gt-2026-0827-marriage",
    title: "顶流歌手疑似已隐婚多年，所谓“配偶”信息无法核实",
    category: "恋情绯闻",
    summary:
      "爆料称该歌手多年前已登记结婚，并给出一个姓氏与所在城市。该说法在多个账号间转发，但均指向同一张模糊截图，无法进一步核实。",
    credibility: 41,
    verdict: "待定",
    heat: 17600,
    publishedAt: "2026-09-02",
    readMinutes: 5,
    tags: ["单一截图", "同源转发", "无法核实"],
    cover: "https://readdy.ai/api/search-image?query=blurred%20unreadable%20document%20photograph%20on%20a%20dark%20table%20beside%20a%20sealed%20envelope%2C%20low%20key%20warm%20lighting%2C%20editorial%20mystery%20still%20life%2C%20cream%20and%20deep%20red%20tones%2C%20high%20detail&width=800&height=600&seq=gt-marry-2026&orientation=landscape",
    coverAlt: "隐婚传闻爆料鉴定：模糊的文件照片",
    conclusion:
      "所有转述均来自同一张无法辨认的截图，属同源信息反复放大，既不满足实锤条件，也没有出现可推翻的硬反证，暂列待定。",
    evidence: [
      {
        id: "e1",
        type: "核心材料",
        title: "唯一材料是一张模糊截图",
        detail: "关键字段无法辨认，无法判断来源与真实性。",
        weight: "低",
      },
      {
        id: "e2",
        type: "传播路径",
        title: "多条爆料实为同源转发",
        detail: "不同账号内容措辞高度一致，属同源扩散，不能算作多方印证。",
        weight: "低",
      },
      {
        id: "e3",
        type: "反证核查",
        title: "暂无可推翻的硬反证",
        detail: "当事人未回应，因此既不能确认也不能否定。",
        weight: "中",
      },
      {
        id: "e4",
        type: "隐私提醒",
        title: "涉及婚姻登记等个人信息",
        detail: "此类信息属于隐私范畴，即使存在也不宜公开传播与二次加工。",
        weight: "中",
      },
    ],
    timeline: [
      { time: "08-29 21:00", event: "首条爆料发布，仅配一张模糊截图。" },
      { time: "08-31 13:00", event: "多条内容几乎一致的转述出现，热度上升。" },
      { time: "09-01 10:00", event: "网友指出所有爆料指向同一来源。" },
      { time: "09-02 09:00", event: "瓜田爆料判定为待定，并提示隐私边界。" },
    ],
    sources: [
      { name: "原始爆料帖", type: "单一来源", note: "材料不可辨认" },
      { name: "多条转述内容", type: "同源转发", note: "措辞高度一致" },
      { name: "当事人账号", type: "公开记录", note: "未就此事回应" },
    ],
    assessment: [
      { dimension: "源头可查性", score: 30, note: "来源单一且不可辨认" },
      { dimension: "证据链完整度", score: 35, note: "无其他佐证" },
      { dimension: "多方交叉印证", score: 25, note: "实为同源扩散" },
      { dimension: "官方回应情况", score: 35, note: "未回应" },
    ],
  },
];